import { COLORS } from '@btime/constants'
import { formatDate } from '@btime/helpers'
import { prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText, Title } from '../../../components/presentation/Text'
import { useTemplate } from './_load/TemplateLoader'
import DeletedTag from '../../../components/helpers/DeletedTag'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Separator from '../../../components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('templates')
  const template = useTemplate()

  const name = prop('name', template)
  const enabled = prop('enabled', template)
  const updatedAt = formatDate('DD/MM/YYYY - HH:mm')(prop('updatedAt', template))
  const insertedAt = formatDate('DD/MM/YYYY - HH:mm')(prop('insertedAt', template))

  return (
    <>
      <FlexGrid justify="flex-start" gutter={0.3}>
        <FlexCol flex={1} width="100%">
          <Title size="h4" strong color={COLORS.dark2} noMargin>
            {name}
          </Title>
          <SmallText color={COLORS.dark3} align="left">
            {t('insertedAt')} {insertedAt}
          </SmallText>
        </FlexCol>

        <FlexCol flex={1} />

        <FlexCol>
          <DeletedTag entity={template} />
        </FlexCol>
      </FlexGrid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
